import {Injectable} from '@angular/core';
import {RouterService} from '@npck/libs/commons';
import {TableEvent} from '../components/full-table/full-table.component';
import {OrganizationTab} from '../pages/admin/organizations/details/organization-details.component';
import {Path} from '../path';

@Injectable({providedIn: 'root'})
export class OrganizationDetailsFilterHolderService {
    private stateByOrganization: Record<string, Partial<Record<OrganizationTab, TableEvent>>> = {};

    constructor(
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.ADMIN_PANEL)) {
                    this.clear();
                }
            });
    }

    getState(organizationId: string, tab: OrganizationTab): TableEvent | undefined {
        return this.stateByOrganization[organizationId]?.[tab];
    }

    storeTableState(organizationId: string, tab: OrganizationTab, tableEvent: TableEvent): TableEvent {
        this.stateByOrganization[organizationId] = this.stateByOrganization[organizationId] ?? {};
        const newState: TableEvent = {...tableEvent, filter: {...tableEvent.filter}};
        this.stateByOrganization[organizationId][tab] = newState;
        return newState;
    }

    clear(): void {
        this.stateByOrganization = {};
    }
}
